// @flow
import firebase from '../firebase'
import {useState, useEffect} from 'react'

export default function useGetDeviceKey (): ?string {
  const [deviceKey, setDeviceKey] = useState(null)
  const allDevicesRef = firebase.database().ref(`devices`)
  useEffect(() => {

    try {
      const storedKey = window.localStorage[`afa-order-device-key`] || null
      if (storedKey) {
        setDeviceKey(storedKey)
        return
      }
    } catch (e) {
      console.log(e)
    }

    if (!deviceKey) {
      const newKey = allDevicesRef.push().key
      try {
        window.localStorage[`afa-order-device-key`] = newKey
      } catch(e) {
        console.log(e)
      }
      setDeviceKey( newKey )
    }
    console.log("device key:", deviceKey)

  }, [0]) // only ran once

  return deviceKey
}
